import { useState } from "react";
import Form from "components/common/form/form";
import Input from "../../inputs/input";
import Radio from "@/components/common/form/checkbox";
import Textarea from "../../inputs/textarea";
import Button from "@/components/common/form/button";
import { useTranslation } from "react-i18next";
import { ContactUsService } from "services/contact-us.service";
import * as yup from "yup";
import SayThanksModal from "./sayThanksModal";
function Name({ passProps, ...props }) {
  return <Input label="name" name="name" {...props} />;
}

function SubmitButton(props) {
  return (
    <Button
      className="w-full bg-main py-2.5 rounded-md text-white"
      title={props.t("Send")}
      loading={props?.formState?.isSubmitting ?? false}
    />
  );
}

function index() {
  const sendMessage = async (e) => {
    try {
      await fetch("/api/contact", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: e.name,
          email: e.email,
          message: e.message,
          contact: e.contact,
          farming_type: e.farming_type,
          company_name: e.company_name,
        }),
      });
    } catch (err) {
      console.log(err);
    }
  };
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const onSubmit = async (data) => {
    let res = await ContactUsService.contactUs(data);
    if (res) {
      setShowModal(true);
      sendMessage(res.data);
    }
  };

  const schema = yup.object({
    contact: yup
      .string()
      .required(t("Phone_Number_is_a_required_field"))
      .max(13, t("Must be a valid Number Exp: +xxxxxxxxxxx"))
      .min(13, t("Must be a valid Number Exp: +xxxxxxxxxxx"))
      .matches(
        /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/,
        t("Must be a valid Number Exp: +xxxxxxxxxxx")
      ),
    name: yup.string().required(t("Name_is_a_required_field")),
    email: yup.string().email().required(t("Email_is_a_required_field")),
    company_name: yup.string().required(t("Company_Name_is_a_required_field")),
    farming_type: yup.array().required(t("this field is required")),
    message: yup.string().required(t("Message_is_a_required_field")),
  });

  return (
    <div
      id="ContactUs"
      className={`container m-auto py-15"  ${!showModal ? "py-15" : ""} ${
        showModal ? "my-5" : ""
      }`}
    >
      {!showModal ? (
        <>
          <div className="text-3xl font-bold text-center">
            {t("CONTACT US")}
          </div>
          <div className="mt-5 text-[#717171]  text-center m-auto text-[20px] ">
            {t(
              "Once we receive your message, we will contact you as early as poosible and discuss ways forward"
            )}
          </div>
          <Form
            schema={schema}
            onSubmit={onSubmit}
            className="text-[#717171] mt-15 max-w-[878px] m-auto"
          >
            <div className="flex items-center justify-center gap-5 mb-8">
              <div className="w-[422px]">
                <div>{t("Name")}</div>
                <Name passProps />
              </div>
              <div className="w-[422px]">
                <div>{t("Email")}</div>
                <Input type={"email"} name="email" label="email" />
              </div>
            </div>
            <div className="flex items-center justify-center gap-5 mb-8">
              <div className="w-[422px]">
                <div>{t("Phone Number")}</div>
                <Input name="contact" label="contact" />
              </div>
              <div className="w-[422px]">
                <div>{t("Company Name")}</div>
                <Input name="company_name" label="company_name" />
              </div>
            </div>
            <div className="mb-8">
              <div>{t("Farm Type")}</div>
              <Radio
                label="farming_type"
                name="farming_type"
                withoutLabel={true}
                options={[
                  { label: t("Tree Farming"), value: "tree" },
                  {
                    label: t("Crop farming"),
                    value: "crop",
                  },
                ]}
              />
            </div>
            <div>{t("Messege")}</div>
            <div>
              <Textarea label={t("Messege")} name="message" />
            </div>
            <SubmitButton passProps t={t}></SubmitButton>
          </Form>
        </>
      ) : (
        <div className="my-2">
          <SayThanksModal showModal={showModal} setShowModal={setShowModal} />
        </div>
      )}
    </div>
  );
}

export default index;
